import type { ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { appUrl, type PlatformAppId } from "../config/environment";
import { requireFrontendSession } from "../services/authSession";
export async function mountFrontend(root: HTMLElement, application: ReactNode, app: PlatformAppId) {
  root.setAttribute("aria-busy", "true");
  root.dataset.app = app;
  try {
    const session = await requireFrontendSession();
    if (!session) return;
    root.dataset.sessionSubject = session.subject;
    root.dataset.sessionName = session.name;
    root.dataset.sessionEmail = session.email;
    root.dataset.sessionRole = session.role;
    root.dataset.sessionWorkspace = session.workspaceId;
    root.removeAttribute("aria-busy");
    createRoot(root).render(application);
  } catch (error) {
    root.removeAttribute("aria-busy");
    createRoot(root).render(
      <main style={{ padding: 24, background: "#ffffff", color: "#18233a" }}>
        <h1>Unable to open this workspace</h1>
        <p role="alert">{error instanceof Error ? error.message : "Academy is unavailable."}</p>
        <button onClick={() => window.location.reload()}>Try again</button>{" "}
        <a href={appUrl("auth")} style={{ color: "#1644a2" }}>
          Open Academy Access
        </a>
      </main>,
    );
  }
}
